import { Mark_Type } from "./../../ricos-types";
import { createRicosMarkExtension } from "./../../plugin-commons";
import findHashTag from "./findHashTag";
const tiptapExtensions = [
  createRicosMarkExtension({
    type: "mark",
    groups: [],
    name: Mark_Type.HASHTAG,
    createExtensionConfig({ Plugin }) {
      return {
        name: this.name,
        addProseMirrorPlugins() {
          return [
            new Plugin({
              state: {
                init(_, { doc }) {
                  return findHashTag(doc);
                },
                apply(transaction, oldState) {
                  return transaction.docChanged ? findHashTag(transaction.doc) : oldState;
                }
              },
              props: {
                decorations(state) {
                  return this.getState(state);
                }
              }
            })
          ];
        }
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
